import {Middleware} from 'redux';
import {IReduxStoreState} from '../@interfaces';
import createSagaMiddleware from 'redux-saga';
import app from '../helpers/app';
import {RunSagaOptions} from '@redux-saga/core';
import {setFatalError} from './app/actions';

export const loggerMiddleware: Middleware<any, IReduxStoreState> = api => next => action => {
    if (localStorage?.['disable-redux-logger'] === 'true' || process.env.NODE_ENV !== 'development') {
        return next(action);
    }

    const previousState = api.getState();
    const result = next(action);
    const nextState = api.getState();

    const isSagaAction = action['@@redux-saga/SAGA_ACTION'] === true;

    console.groupCollapsed(
        `%c${action.type}`,
        'font-weight:bold;font-size:14;color:' + (isSagaAction ? 'rgb(184, 23, 157)' : 'rgb(23, 162, 184)')
    );
    console.log('%cPrevious state: ', 'font-weight:bold', previousState);
    console.log('%cAction: ', 'font-weight:bold', action);
    console.log('%cNext state: ', 'font-weight:bold', nextState);
    console.groupEnd();

    return result;
};

export const sagaMiddleware = createSagaMiddleware({
    onError(this: RunSagaOptions<any, any>, error: Error) {
        const errorHandler = app('errorHandler');
        if (errorHandler) {
            errorHandler.handle(error);
        }

        const dispatcher = this.dispatch;
        if (dispatcher) {
            dispatcher(setFatalError(error));
        }
    }
});

export const crashReporter: Middleware<any, IReduxStoreState> = () => next => action => {
    try {
        return next(action);
    } catch (error: any) {
        const errorHandler = app('errorHandler');
        if (errorHandler) {
            errorHandler.handle(error);
        }

        throw error;
    }
};

export const eventsMiddleware: Middleware<any, IReduxStoreState> = api => next => action => {
    const dispatcher = app('store-events');
    if (dispatcher) {
        dispatcher.dispatch(action.type, {api, action});
    }

    return next(action);
};

export default [
    crashReporter,
    loggerMiddleware,
    eventsMiddleware,
    sagaMiddleware,
];
